(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-backupAug26"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.onScroll = this.onScroll.bind(this);
      this.onWheel = this.onWheel.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
      this.onMobileMenuToggle = this.onMobileMenuToggle.bind(this);
      this.onMobileMenuMutation = this.onMobileMenuMutation.bind(this);
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');

      if (!this.header) return;

      this.nav = this.querySelector('.header__inline-menu');
      this.mainHeader = this.querySelector('.header');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.desktopMedia = window.matchMedia('(min-width: 990px)');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.viewportWidth = this.getViewportWidth();
      this.desktopState = this.isDesktop();

      this.lastScrollTop = this.getScrollTop();
      this.scrollAnchor = this.lastScrollTop;

      /* Hysteresis thresholds prevent tiny trackpad movements from repeatedly
         reversing the header state. Desktop uses a deliberately larger travel
         distance because collapsing the navigation changes the header height. */
      this.desktopHideThreshold = 120;
      this.desktopRevealThreshold = 36;
      this.mobileHideThreshold = 22;
      this.mobileRevealThreshold = 14;

      /* When returning towards the top on desktop, restore the full navigation
         before the sticky header reaches the announcement-bar handover area.
         This is based only on page scroll position, so the two sections remain
         independent. */
      this.desktopTopRevealPoint = 520;

      this.hideStart = 40;
      this.transitionLockUntil = 0;
      this.transitionTimer = null;
      this.scrollTicking = false;
      this.resizeTimer = null;

      this.mobileAnimationTargetHidden = false;
      this.mobileTransitionFrame = null;
      this.pageScrollLocked = false;
      this.lockedScrollY = 0;
      this.scrollLockState = null;
      this.mobileMenuDetails = null;
      this.mobileMenuObserver = null;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'shopify-section-header-initialising'
      );

      this.measureHeader();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('wheel', this.onWheel, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      window.addEventListener('pageshow', this.onPageShow);

      this.setupMobileMenuLock();

      if (!this.isDesktop()) {
        this.animateMobilePanel(false, true);
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.lastScrollTop = this.getScrollTop();
          this.header.classList.remove('shopify-section-header-initialising');
        });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('wheel', this.onWheel);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('pageshow', this.onPageShow);
      window.clearTimeout(this.resizeTimer);
      window.clearTimeout(this.transitionTimer);
      document.documentElement.classList.remove('ph-header-transitioning');

      this.cancelMobileAnimation(true);
      this.mobileMenuDetails?.removeEventListener('toggle', this.onMobileMenuToggle);
      this.mobileMenuObserver?.disconnect();
      this.unlockPageScroll();
    }

    getScrollTop() {
      return Math.max(
        window.pageYOffset || document.documentElement.scrollTop || 0,
        0
      );
    }

    getViewportWidth() {
      return Math.round(
        document.documentElement.clientWidth || window.innerWidth || 0
      );
    }

    isDesktop() {
      return this.desktopMedia.matches;
    }

    isHeaderHidden() {
      return this.isDesktop()
        ? this.header.classList.contains('shopify-section-header-hidden')
        : this.header.classList.contains('ph-mobile-header-hidden');
    }

    measureHeader() {
      let navHeight = 0;

      if (this.nav) {
        /* Measure the visible navigation wrapper rather than scrollHeight.
           scrollHeight includes the invisible desktop mega-menu hover bridge. */
        const navContent = this.nav.firstElementChild;

        navHeight = Math.ceil(
          (navContent || this.nav).getBoundingClientRect().height
        );
      }

      if (navHeight) {
        this.header.style.setProperty('--ph-header-nav-height', `${navHeight}px`);
      }

      const fullHeaderHeight = Math.ceil(this.header.offsetHeight);

      document.documentElement.style.setProperty(
        '--header-height',
        `${fullHeaderHeight}px`
      );

      this.updateLiveHeaderHeight();
    }

    updateLiveHeaderHeight() {
      requestAnimationFrame(() => {
        /* A transform does not change layout height. Keep this value stable on
           mobile so other theme components do not react while the panel moves. */
        const liveHeight = Math.ceil(this.header.offsetHeight);

        document.documentElement.style.setProperty(
          '--header-height-live',
          `${liveHeight}px`
        );
      });
    }

    cancelMobileAnimation(clearTransform = false) {
      if (this.mobileTransitionFrame) {
        cancelAnimationFrame(this.mobileTransitionFrame);
        this.mobileTransitionFrame = null;
      }

      this.style.removeProperty('transition');
      this.style.removeProperty('--ph-mobile-header-duration');

      if (clearTransform) {
        this.style.removeProperty('transform');
      }
    }

    animateMobilePanel(hidden, immediate = false) {
      if (this.isDesktop()) return;

      const targetTransform = hidden
        ? 'translate3d(0, -101%, 0)'
        : 'translate3d(0, 0, 0)';

      this.mobileAnimationTargetHidden = hidden;

      if (this.mobileTransitionFrame) {
        cancelAnimationFrame(this.mobileTransitionFrame);
        this.mobileTransitionFrame = null;
      }

      if (immediate) {
        /* Establish the requested position without animation, then restore the
           persistent CSS transition on the following frame. This is used only
           for initial load, page restoration and breakpoint changes. */
        this.style.setProperty('transition', 'none', 'important');
        this.style.setProperty('transform', targetTransform, 'important');

        /* Force the browser to commit the non-animated position before the
           transition is re-enabled. */
        void this.offsetHeight;

        this.mobileTransitionFrame = requestAnimationFrame(() => {
          this.style.removeProperty('transition');
          this.mobileTransitionFrame = null;
        });

        return;
      }

      /* Do not calculate, cancel or restart an animation. Changing only the
         transform destination lets the browser's native transition continue
         from the panel's exact current visual position. This also makes rapid
         direction changes reverse smoothly instead of snapping. */
      this.style.removeProperty('transition');
      this.style.setProperty('--ph-mobile-header-duration', '440ms');
      this.style.setProperty('transform', targetTransform, 'important');
    }

    setupMobileMenuLock() {
      this.mobileMenuDetails = this.querySelector(
        'header-drawer > details, header-drawer details.menu-drawer-container, details.menu-drawer-container'
      );

      if (!this.mobileMenuDetails) return;

      this.mobileMenuDetails.addEventListener('toggle', this.onMobileMenuToggle);

      this.mobileMenuObserver = new MutationObserver(
        this.onMobileMenuMutation
      );
      this.mobileMenuObserver.observe(this.mobileMenuDetails, {
        attributes: true,
        attributeFilter: ['open', 'class']
      });

      this.onMobileMenuToggle();
    }

    onMobileMenuMutation() {
      this.onMobileMenuToggle();
    }

    onMobileMenuToggle() {
      const menuIsOpen = Boolean(
        this.mobileMenuDetails &&
        (
          this.mobileMenuDetails.open ||
          this.mobileMenuDetails.classList.contains('menu-opening')
        )
      );

      if (menuIsOpen && !this.isDesktop()) {
        this.reveal();
        this.lockPageScroll();
        return;
      }

      this.unlockPageScroll();
    }

    lockPageScroll() {
      if (this.pageScrollLocked || this.isDesktop()) return;

      const html = document.documentElement;
      const body = document.body;

      this.pageScrollLocked = true;
      this.lockedScrollY = this.getScrollTop();
      this.scrollLockState = {
        htmlOverflow: html.style.overflow,
        bodyOverflow: body.style.overflow,
        bodyPosition: body.style.position,
        bodyTop: body.style.top,
        bodyLeft: body.style.left,
        bodyRight: body.style.right,
        bodyWidth: body.style.width
      };

      html.classList.add('ph-mobile-menu-locked');
      body.classList.add('ph-mobile-menu-locked');

      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
      body.style.position = 'fixed';
      body.style.top = `-${this.lockedScrollY}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
    }

    unlockPageScroll() {
      if (!this.pageScrollLocked) return;

      const html = document.documentElement;
      const body = document.body;
      const scrollY = this.lockedScrollY;
      const state = this.scrollLockState || {};

      const restore = (element, property, value) => {
        if (value) {
          element.style.setProperty(property, value);
        } else {
          element.style.removeProperty(property);
        }
      };

      restore(html, 'overflow', state.htmlOverflow);
      restore(body, 'overflow', state.bodyOverflow);
      restore(body, 'position', state.bodyPosition);
      restore(body, 'top', state.bodyTop);
      restore(body, 'left', state.bodyLeft);
      restore(body, 'right', state.bodyRight);
      restore(body, 'width', state.bodyWidth);

      html.classList.remove('ph-mobile-menu-locked');
      body.classList.remove('ph-mobile-menu-locked');

      this.pageScrollLocked = false;
      this.scrollLockState = null;
      this.lockedScrollY = 0;

      window.scrollTo(0, scrollY);
      this.lastScrollTop = scrollY;
      this.scrollAnchor = scrollY;
    }

    onResize() {
      const nextWidth = this.getViewportWidth();
      const nextDesktopState = this.isDesktop();
      const breakpointChanged = nextDesktopState !== this.desktopState;
      const widthChanged = Math.abs(nextWidth - this.viewportWidth) >= 8;

      /* Mobile browsers frequently emit resize events when the address bar
         expands or contracts during a normal scroll. Those events alter the
         viewport height, not the layout width, and must not reset the header.
         The previous handler called reveal(false), causing an occasional snap. */
      if (!breakpointChanged && !widthChanged) return;

      window.clearTimeout(this.resizeTimer);

      this.resizeTimer = window.setTimeout(() => {
        const liveWidth = this.getViewportWidth();
        const liveDesktopState = this.isDesktop();
        const liveBreakpointChanged = liveDesktopState !== this.desktopState;
        const liveWidthChanged = Math.abs(liveWidth - this.viewportWidth) >= 8;

        if (!liveBreakpointChanged && !liveWidthChanged) return;

        this.header.classList.add('shopify-section-header-initialising');

        /* Only reset visibility when crossing the desktop/mobile breakpoint.
           Ordinary width changes preserve the current hidden or visible state. */
        if (liveBreakpointChanged) {
          this.cancelMobileAnimation(liveDesktopState);

          if (liveDesktopState) {
            this.unlockPageScroll();
          }

          this.reveal(false);
        }

        requestAnimationFrame(() => {
          this.measureHeader();
          this.viewportWidth = liveWidth;
          this.desktopState = liveDesktopState;
          this.lastScrollTop = this.getScrollTop();
          this.scrollAnchor = this.lastScrollTop;
          this.transitionLockUntil = 0;
          this.header.classList.remove('shopify-section-header-initialising');
        });
      }, 120);
    }

    onPageShow() {
      this.lastScrollTop = this.getScrollTop();
      this.scrollAnchor = this.lastScrollTop;
      this.transitionLockUntil = 0;
      this.reveal(false);
      this.measureHeader();
    }

    interactionIsOpen() {
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return true;

      return Boolean(
        this.querySelector('details[open], .menu-opening, [aria-expanded="true"].header__icon--menu')
      );
    }

    onWheel(event) {
      /* On desktop, a mouse wheel or trackpad reports upward intent before the
         corresponding scroll movement is painted. Starting the top-approach
         expansion here gives the navigation time to finish before the sticky
         header returns to its normal document position. */
      if (
        !this.isDesktop() ||
        this.headerIsAlwaysSticky ||
        event.ctrlKey ||
        event.deltaY >= 0
      ) {
        return;
      }

      const scrollTop = this.getScrollTop();

      if (scrollTop > this.desktopTopRevealPoint) return;

      this.header.classList.add('ph-desktop-pretop-reveal');
      this.scrollAnchor = scrollTop;
      this.reveal();
    }

    onScroll() {
      if (this.scrollTicking) return;

      this.scrollTicking = true;

      requestAnimationFrame(() => {
        this.scrollTicking = false;

        const scrollTop = this.getScrollTop();
        const now = performance.now();
        const previousScrollTop = this.lastScrollTop;
        const scrollingUp = scrollTop < previousScrollTop;

        this.lastScrollTop = scrollTop;

        if (this.pageScrollLocked) {
          this.scrollAnchor = this.lockedScrollY;
          return;
        }

        if (this.headerIsAlwaysSticky) {
          this.scrollAnchor = scrollTop;
          this.reveal();
          return;
        }

        /* Desktop top-approach safety zone. If the user is moving upwards,
           reveal the full navigation while there is still ample page distance
           for its height transition to finish. The announcement bar is neither
           queried nor controlled here. */
        if (
          this.isDesktop() &&
          scrollingUp &&
          scrollTop <= this.desktopTopRevealPoint
        ) {
          this.header.classList.add('ph-desktop-pretop-reveal');
          this.scrollAnchor = scrollTop;
          this.reveal();
          return;
        }

        if (this.isDesktop() && scrollTop > this.desktopTopRevealPoint) {
          this.header.classList.remove('ph-desktop-pretop-reveal');
        }

        if (scrollTop <= this.hideStart) {
          if (this.isDesktop()) {
            this.header.classList.add('ph-desktop-pretop-reveal');
          }

          this.scrollAnchor = scrollTop;
          this.reveal();
          return;
        }

        if (this.interactionIsOpen()) {
          this.scrollAnchor = scrollTop;
          this.reveal();
          return;
        }

        /* Ignore scroll events produced while the header itself is changing
           height or position. Continue updating the anchor so no artificial
           distance is carried into the next genuine user scroll. */
        if (now < this.transitionLockUntil) {
          this.scrollAnchor = scrollTop;
          return;
        }

        const hidden = this.isHeaderHidden();
        const hideThreshold = this.isDesktop()
          ? this.desktopHideThreshold
          : this.mobileHideThreshold;
        const revealThreshold = this.isDesktop()
          ? this.desktopRevealThreshold
          : this.mobileRevealThreshold;

        if (!hidden) {
          /* While visible, an upward movement establishes a new low point.
             The header only hides after a deliberate downward journey from it. */
          if (scrollTop < this.scrollAnchor) {
            this.scrollAnchor = scrollTop;
            return;
          }

          if (scrollTop - this.scrollAnchor < hideThreshold) return;

          this.scrollAnchor = scrollTop;
          this.hide();
          return;
        }

        /* While hidden, a downward movement establishes a new high point.
           The header only reveals after a deliberate upward journey from it. */
        if (scrollTop > this.scrollAnchor) {
          this.scrollAnchor = scrollTop;
          return;
        }

        if (this.scrollAnchor - scrollTop < revealThreshold) return;

        this.scrollAnchor = scrollTop;
        this.reveal();
      });
    }

    lockScrollDuringTransition() {
      /* The lock is only required on desktop, where collapsing the navigation
         changes the header height and can create synthetic reverse-scroll
         events. Mobile uses transform only, so locking it prevents a fast
         upward gesture from smoothly reversing an in-progress hide animation. */
      if (!this.isDesktop()) {
        this.transitionLockUntil = 0;
        document.documentElement.classList.remove('ph-header-transitioning');
        window.clearTimeout(this.transitionTimer);
        return;
      }

      const duration = 430;

      this.transitionLockUntil = performance.now() + duration;
      document.documentElement.classList.add('ph-header-transitioning');
      window.clearTimeout(this.transitionTimer);

      this.transitionTimer = window.setTimeout(() => {
        document.documentElement.classList.remove('ph-header-transitioning');
        this.lastScrollTop = this.getScrollTop();
        this.scrollAnchor = this.lastScrollTop;
        this.transitionLockUntil = 0;
      }, duration + 40);
    }

    hide() {
      if (!this.isDesktop()) {
        if (
          this.header.classList.contains('ph-mobile-header-hidden') ||
          this.pageScrollLocked
        ) {
          return;
        }

        this.header.classList.add(
          'ph-mobile-header-hidden',
          'shopify-section-header-sticky',
          'scrolling-down'
        );

        this.header.classList.remove(
          'shopify-section-header-hidden',
          'ph-desktop-pretop-reveal',
          'animate',
          'scrolling-up'
        );

        this.animateMobilePanel(true);
        this.closeMenuDisclosure();
        this.closeSearchModal();
        this.updateLiveHeaderHeight();
        return;
      }

      if (this.header.classList.contains('shopify-section-header-hidden')) return;

      this.header.classList.remove('ph-mobile-header-hidden');
      this.lockScrollDuringTransition();

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'scrolling-down'
      );

      this.header.classList.remove('animate', 'scrolling-up');

      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.updateLiveHeaderHeight();
    }

    reveal(animate = true) {
      if (!this.isDesktop()) {
        this.header.classList.add(
          'shopify-section-header-sticky',
          'scrolling-up'
        );
        this.header.classList.toggle('animate', animate);

        this.header.classList.remove(
          'ph-mobile-header-hidden',
          'shopify-section-header-hidden',
          'scrolling-down'
        );

        this.animateMobilePanel(false, !animate);
        this.updateLiveHeaderHeight();
        return;
      }

      this.cancelMobileAnimation(true);
      this.header.classList.remove('ph-mobile-header-hidden');

      const wasHidden = this.header.classList.contains('shopify-section-header-hidden');

      if (wasHidden && animate) {
        this.lockScrollDuringTransition();
      }

      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.toggle('animate', animate);
      this.header.classList.add('scrolling-up');

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'scrolling-down'
      );

      this.updateLiveHeaderHeight();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        } else {
          disclosure.querySelector('details[open]')?.removeAttribute('open');
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
      this.onMobileMenuToggle = this.onMobileMenuToggle.bind(this);
      this.onMobileMenuMutation = this.onMobileMenuMutation.bind(this);
      this.onMobileMenuSummaryClick = this.onMobileMenuSummaryClick.bind(this);
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');

      if (!this.header) return;

      this.nav = this.querySelector('.header__inline-menu');
      this.mainHeader = this.querySelector('.header');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.desktopMedia = window.matchMedia('(min-width: 990px)');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.viewportWidth = this.getViewportWidth();
      this.desktopState = this.isDesktop();

      this.lastScrollTop = this.getScrollTop();
      this.scrollAnchor = this.lastScrollTop;

      /* Hysteresis thresholds prevent tiny trackpad movements from repeatedly
         reversing the header state. Desktop uses a deliberately larger travel
         distance because collapsing the navigation changes the header height. */
      this.desktopHideThreshold = 120;
      this.desktopRevealThreshold = 36;
      this.mobileHideThreshold = 22;
      this.mobileRevealThreshold = 14;

      /* When returning towards the top on desktop, restore the full navigation
         before the sticky header reaches the announcement-bar handover area.
         This is based only on page scroll position, so the two sections remain
         independent. */
      this.desktopTopRevealPoint = 520;

      this.hideStart = 110;
      this.transitionLockUntil = 0;
      this.transitionTimer = null;
      this.scrollTicking = false;
      this.resizeTimer = null;

      this.mobileAnimationTargetHidden = false;
      this.mobileTransitionFrame = null;
      this.pageScrollLocked = false;
      this.lockedScrollY = 0;
      this.scrollLockState = null;
      this.mobileMenuDetails = null;
      this.mobileMenuSummary = null;
      this.mobileMenuObserver = null;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'shopify-section-header-initialising'
      );

      this.measureHeader();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      window.addEventListener('pageshow', this.onPageShow);

      this.setupMobileMenuLock();

      if (!this.isDesktop()) {
        this.cancelMobileAnimation(true);
        this.header.classList.remove('ph-mobile-header-hidden', 'shopify-section-header-hidden');
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.lastScrollTop = this.getScrollTop();
          this.header.classList.remove('shopify-section-header-initialising');
        });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('pageshow', this.onPageShow);
      window.clearTimeout(this.resizeTimer);
      window.clearTimeout(this.transitionTimer);
      document.documentElement.classList.remove('ph-header-transitioning');

      this.cancelMobileAnimation(true);

      this.mobileMenuDetails?.removeEventListener(
        'toggle',
        this.onMobileMenuToggle
      );

      this.mobileMenuSummary?.removeEventListener(
        'click',
        this.onMobileMenuSummaryClick,
        true
      );

      this.mobileMenuObserver?.disconnect();
      this.unlockPageScroll();

      this.header?.classList.remove(
        'ph-mobile-menu-preparing',
        'ph-mobile-menu-open'
      );

      this.header?.style.removeProperty('--ph-mobile-menu-top');
    }

    getScrollTop() {
      return Math.max(
        window.pageYOffset || document.documentElement.scrollTop || 0,
        0
      );
    }

    getViewportWidth() {
      return Math.round(
        document.documentElement.clientWidth || window.innerWidth || 0
      );
    }

    isDesktop() {
      return this.desktopMedia.matches;
    }

    isHeaderHidden() {
      return this.isDesktop()
        ? this.header.classList.contains('shopify-section-header-hidden')
        : this.header.classList.contains('ph-mobile-header-hidden');
    }

    measureHeader() {
      let navHeight = 0;

      if (this.nav) {
        /* Measure the visible navigation wrapper rather than scrollHeight.
           scrollHeight includes the invisible desktop mega-menu hover bridge. */
        const navContent = this.nav.firstElementChild;

        navHeight = Math.ceil(
          (navContent || this.nav).getBoundingClientRect().height
        );
      }

      if (navHeight) {
        this.header.style.setProperty('--ph-header-nav-height', `${navHeight}px`);
      }

      const fullHeaderHeight = Math.ceil(this.header.offsetHeight);

      document.documentElement.style.setProperty(
        '--header-height',
        `${fullHeaderHeight}px`
      );

      this.updateHeaderStart();
      this.updateLiveHeaderHeight();
    }

    updateHeaderStart() {
      if (!this.header) return;

      const headerStart = Math.max(
        0,
        Math.round(this.header.getBoundingClientRect().top)
      );

      if (this.lastHeaderStart === headerStart) return;
      this.lastHeaderStart = headerStart;

      document.documentElement.style.setProperty(
        '--header-start-live',
        `${headerStart}px`
      );
    }

      updateLiveHeaderHeight() {
        requestAnimationFrame(() => {
          const liveHeight = Math.ceil(
            this.header.offsetHeight
          );

          if (
            liveHeight ===
            this.lastLiveHeaderHeight
          ) {
            return;
          }

          this.lastLiveHeaderHeight =
            liveHeight;

          document.documentElement.style.setProperty(
            '--header-height-live',
            `${liveHeight}px`
          );
        });
      }

    cancelMobileAnimation(clearTransform = false) {
      if (this.mobileTransitionFrame) {
        cancelAnimationFrame(this.mobileTransitionFrame);
        this.mobileTransitionFrame = null;
      }

      this.style.removeProperty('transition');
      this.style.removeProperty('--ph-mobile-header-duration');

      if (clearTransform) {
        this.style.removeProperty('transform');
      }
    }

    animateMobilePanel(hidden, immediate = false) {
      if (!this.isDesktop()) {
        this.cancelMobileAnimation(true);
        this.mobileAnimationTargetHidden = false;
      }
    }

    setupMobileMenuLock() {
      this.mobileMenuDetails = this.querySelector(
        'header-drawer > details, header-drawer details.menu-drawer-container, details.menu-drawer-container'
      );

      if (!this.mobileMenuDetails) return;

      this.mobileMenuSummary = this.mobileMenuDetails.querySelector('summary');

      this.mobileMenuDetails.addEventListener(
        'toggle',
        this.onMobileMenuToggle
      );

      this.mobileMenuSummary?.addEventListener(
        'click',
        this.onMobileMenuSummaryClick,
        true
      );

      this.mobileMenuObserver = new MutationObserver(
        this.onMobileMenuMutation
      );

      this.mobileMenuObserver.observe(this.mobileMenuDetails, {
        attributes: true,
        attributeFilter: ['open', 'class']
      });

      this.onMobileMenuToggle();
    }

    onMobileMenuMutation() {
      this.onMobileMenuToggle();
    }

    onMobileMenuSummaryClick() {
      if (
        this.isDesktop() ||
        !this.mobileMenuDetails ||
        this.mobileMenuDetails.open
      ) {
        return;
      }

      /*
       * This runs before the native details toggle.
       * Removing the transform first allows the drawer to calculate its
       * position from the viewport.
       */
      this.prepareMobileMenuOpen();
    }

    prepareMobileMenuOpen() {
      if (this.isDesktop() || !this.header) return;

      const currentTop = Math.max(
        0,
        Math.round(this.header.getBoundingClientRect().top)
      );

      this.header.style.setProperty(
        '--ph-mobile-menu-top',
        `${currentTop}px`
      );

      this.header.classList.add(
        'shopify-section-header-sticky',
        'scrolling-up',
        'ph-mobile-menu-preparing'
      );

      this.header.classList.remove(
        'ph-mobile-header-hidden',
        'shopify-section-header-hidden',
        'scrolling-down',
        'animate'
      );

      this.cancelMobileAnimation(false);
      this.style.setProperty('transition', 'none', 'important');
      this.style.removeProperty('transform');

      /*
       * Force the browser to commit transform:none before the drawer
       * calculates its opening position.
       */
      void this.offsetHeight;
    }

    finishMobileMenuClose() {
      if (!this.header) return;

      this.unlockPageScroll();

      this.header.classList.remove(
        'ph-mobile-menu-preparing',
        'ph-mobile-menu-open'
      );

      this.header.style.removeProperty('--ph-mobile-menu-top');

      /*
       * Return the header to its standard visible mobile state without
       * animating from the temporary fixed position.
       */
      this.animateMobilePanel(false, true);

      this.header.classList.remove(
        'ph-mobile-header-hidden',
        'scrolling-down'
      );

      this.header.classList.add(
        'shopify-section-header-sticky',
        'scrolling-up'
      );

      this.lastScrollTop = this.getScrollTop();
      this.scrollAnchor = this.lastScrollTop;
    }

    onMobileMenuToggle() {
      const menuIsOpen = Boolean(
        this.mobileMenuDetails &&
        (
          this.mobileMenuDetails.open ||
          this.mobileMenuDetails.classList.contains('menu-opening')
        )
      );

      if (menuIsOpen && !this.isDesktop()) {
        this.prepareMobileMenuOpen();

        this.header.classList.add('ph-mobile-menu-open');
        this.header.classList.remove('ph-mobile-menu-preparing');

        this.lockPageScroll();
        return;
      }

      this.finishMobileMenuClose();
    }

    lockPageScroll() {
      if (this.pageScrollLocked || this.isDesktop()) return;

      const html = document.documentElement;
      const body = document.body;

      this.pageScrollLocked = true;
      this.lockedScrollY = this.getScrollTop();
      this.scrollLockState = {
        htmlOverflow: html.style.overflow,
        bodyOverflow: body.style.overflow,
        htmlOverscrollBehavior: html.style.overscrollBehavior,
        bodyOverscrollBehavior: body.style.overscrollBehavior
      };

      html.classList.add('ph-mobile-menu-locked');
      body.classList.add('ph-mobile-menu-locked');

      /* Keep the document at its real scroll position. Fixing the body and
         applying a negative top offset causes the visible page to jump when
         the drawer opens and closes, especially with mobile browser chrome. */
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
      html.style.overscrollBehavior = 'none';
      body.style.overscrollBehavior = 'none';
    }

    unlockPageScroll() {
      if (!this.pageScrollLocked) return;

      const html = document.documentElement;
      const body = document.body;
      const state = this.scrollLockState || {};

      const restore = (element, property, value) => {
        if (value) {
          element.style.setProperty(property, value);
        } else {
          element.style.removeProperty(property);
        }
      };

      restore(html, 'overflow', state.htmlOverflow);
      restore(body, 'overflow', state.bodyOverflow);
      restore(
        html,
        'overscroll-behavior',
        state.htmlOverscrollBehavior
      );
      restore(
        body,
        'overscroll-behavior',
        state.bodyOverscrollBehavior
      );

      html.classList.remove('ph-mobile-menu-locked');
      body.classList.remove('ph-mobile-menu-locked');

      this.pageScrollLocked = false;
      this.scrollLockState = null;
      this.lockedScrollY = 0;

      /* The page never left its original scroll position, so no restorative
         window.scrollTo call is required. Avoiding that call removes the
         closing jump as well. */
      const scrollTop = this.getScrollTop();
      this.lastScrollTop = scrollTop;
      this.scrollAnchor = scrollTop;
    }

    onResize() {
      const nextWidth = this.getViewportWidth();
      const nextDesktopState = this.isDesktop();
      const breakpointChanged = nextDesktopState !== this.desktopState;
      const widthChanged = Math.abs(nextWidth - this.viewportWidth) >= 8;

      /* Mobile browsers frequently emit resize events when the address bar
         expands or contracts during a normal scroll. Those events alter the
         viewport height, not the layout width, and must not reset the header.
         The previous handler called reveal(false), causing an occasional snap. */
      if (!breakpointChanged && !widthChanged) return;

      window.clearTimeout(this.resizeTimer);

      this.resizeTimer = window.setTimeout(() => {
        const liveWidth = this.getViewportWidth();
        const liveDesktopState = this.isDesktop();
        const liveBreakpointChanged = liveDesktopState !== this.desktopState;
        const liveWidthChanged = Math.abs(liveWidth - this.viewportWidth) >= 8;

        if (!liveBreakpointChanged && !liveWidthChanged) return;

        this.header.classList.add('shopify-section-header-initialising');

        /* Only reset visibility when crossing the desktop/mobile breakpoint.
           Ordinary width changes preserve the current hidden or visible state. */
        if (liveBreakpointChanged) {
          this.cancelMobileAnimation(liveDesktopState);

          if (liveDesktopState) {
            this.unlockPageScroll();
          }

          this.reveal(false);
        }

        requestAnimationFrame(() => {
          this.measureHeader();
          this.viewportWidth = liveWidth;
          this.desktopState = liveDesktopState;
          this.lastScrollTop = this.getScrollTop();
          this.scrollAnchor = this.lastScrollTop;
          this.transitionLockUntil = 0;
          this.header.classList.remove('shopify-section-header-initialising');
        });
      }, 120);
    }

    onPageShow() {
      this.lastScrollTop = this.getScrollTop();
      this.scrollAnchor = this.lastScrollTop;
      this.transitionLockUntil = 0;
      this.reveal(false);
      this.measureHeader();
    }

    interactionIsOpen() {
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return true;

      return Boolean(
        this.querySelector('details[open], .menu-opening, [aria-expanded="true"].header__icon--menu')
      );
    }

    onScroll() {
      if (this.scrollTicking) return;

      this.scrollTicking = true;

      requestAnimationFrame(() => {
        this.scrollTicking = false;

        const scrollTop = this.getScrollTop();

        if (!this.isDesktop()) {
          this.lastScrollTop = scrollTop;
          this.scrollAnchor = scrollTop;
          return;
        }

        if (scrollTop < this.hideStart + 180 || this.lastHeaderStart !== 0) {
          this.updateHeaderStart();
        }

        const now = performance.now();
        const previousScrollTop = this.lastScrollTop;
        const scrollingUp = scrollTop < previousScrollTop;

        this.lastScrollTop = scrollTop;

        if (this.pageScrollLocked) {
          this.scrollAnchor = this.lockedScrollY;
          return;
        }

        /* Keep the complete desktop header and navigation row permanently
           visible. Mobile retains its independent hide and reveal behaviour. */
        if (this.isDesktop()) {
          this.scrollAnchor = scrollTop;

          if (this.header.classList.contains('shopify-section-header-hidden')) {
            this.reveal(false);
          }

          return;
        }

        if (this.headerIsAlwaysSticky) {
          this.scrollAnchor = scrollTop;
          this.reveal();
          return;
        }

        /* Desktop top-approach safety zone. If the user is moving upwards,
           reveal the full navigation while there is still ample page distance
           for its height transition to finish. The announcement bar is neither
           queried nor controlled here. */
        if (
          this.isDesktop() &&
          scrollingUp &&
          scrollTop <= this.desktopTopRevealPoint
        ) {
          this.header.classList.add('ph-desktop-pretop-reveal');
          this.scrollAnchor = scrollTop;
          this.reveal();
          return;
        }

        if (this.isDesktop() && scrollTop > this.desktopTopRevealPoint) {
          this.header.classList.remove('ph-desktop-pretop-reveal');
        }

        if (scrollTop <= this.hideStart) {
          if (this.isDesktop()) {
            this.header.classList.add('ph-desktop-pretop-reveal');
          }

          this.scrollAnchor = scrollTop;
          this.reveal();
          return;
        }

        if (this.interactionIsOpen()) {
          this.scrollAnchor = scrollTop;
          this.reveal();
          return;
        }

        /* Ignore scroll events produced while the header itself is changing
           height or position. Continue updating the anchor so no artificial
           distance is carried into the next genuine user scroll. */
        if (now < this.transitionLockUntil) {
          this.scrollAnchor = scrollTop;
          return;
        }

        const hidden = this.isHeaderHidden();
        const hideThreshold = this.isDesktop()
          ? this.desktopHideThreshold
          : this.mobileHideThreshold;
        const revealThreshold = this.isDesktop()
          ? this.desktopRevealThreshold
          : this.mobileRevealThreshold;

        if (!hidden) {
          /* While visible, an upward movement establishes a new low point.
             The header only hides after a deliberate downward journey from it. */
          if (scrollTop < this.scrollAnchor) {
            this.scrollAnchor = scrollTop;
            return;
          }

          if (scrollTop - this.scrollAnchor < hideThreshold) return;

          this.scrollAnchor = scrollTop;
          this.hide();
          return;
        }

        /* While hidden, a downward movement establishes a new high point.
           The header only reveals after a deliberate upward journey from it. */
        if (scrollTop > this.scrollAnchor) {
          this.scrollAnchor = scrollTop;
          return;
        }

        if (this.scrollAnchor - scrollTop < revealThreshold) return;

        this.scrollAnchor = scrollTop;
        this.reveal();
      });
    }

    lockScrollDuringTransition() {
      /* The lock is only required on desktop, where collapsing the navigation
         changes the header height and can create synthetic reverse-scroll
         events. Mobile uses transform only, so locking it prevents a fast
         upward gesture from smoothly reversing an in-progress hide animation. */
      if (!this.isDesktop()) {
        this.transitionLockUntil = 0;
        document.documentElement.classList.remove('ph-header-transitioning');
        window.clearTimeout(this.transitionTimer);
        return;
      }

      const duration = 430;

      this.transitionLockUntil = performance.now() + duration;
      document.documentElement.classList.add('ph-header-transitioning');
      window.clearTimeout(this.transitionTimer);

      this.transitionTimer = window.setTimeout(() => {
        document.documentElement.classList.remove('ph-header-transitioning');
        this.lastScrollTop = this.getScrollTop();
        this.scrollAnchor = this.lastScrollTop;
        this.transitionLockUntil = 0;
      }, duration + 40);
    }

    hide() {
      if (!this.isDesktop()) return;

      if (this.header.classList.contains('shopify-section-header-hidden')) return;

      this.header.classList.remove('ph-mobile-header-hidden');
      this.lockScrollDuringTransition();

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'scrolling-down'
      );

      this.header.classList.remove('animate', 'scrolling-up');

      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.updateLiveHeaderHeight();
    }

    reveal(animate = true) {
      if (!this.isDesktop()) {
        this.cancelMobileAnimation(true);
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove(
          'ph-mobile-header-hidden',
          'shopify-section-header-hidden',
          'scrolling-down',
          'animate'
        );
        return;
      }

      this.cancelMobileAnimation(true);
      this.header.classList.remove('ph-mobile-header-hidden');

      const wasHidden = this.header.classList.contains('shopify-section-header-hidden');

      if (wasHidden && animate) {
        this.lockScrollDuringTransition();
      }

      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.toggle('animate', animate);
      this.header.classList.add('scrolling-up');

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'scrolling-down'
      );

      this.updateLiveHeaderHeight();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        } else {
          disclosure.querySelector('details[open]')?.removeAttribute('open');
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  (() => {
    class MegaMenuHandover {
      constructor(nav) {
        this.nav = nav;
        this.stage = nav.querySelector(':scope > .ph-mega-stage');
        this.menus = Array.from(nav.querySelectorAll('details.mega-menu'));

        if (
          !this.stage ||
          !this.menus.length ||
          nav.dataset.phMegaHandover === 'true'
        ) {
          return;
        }

        nav.dataset.phMegaHandover = 'true';

        this.desktopQuery = window.matchMedia(
          '(min-width: 990px) and (hover: hover) and (pointer: fine)'
        );

        this.reducedMotionQuery = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        this.activeMenu = null;
        this.hideTimer = null;
        this.measureFrame = null;

        this.handleToggle = this.handleToggle.bind(this);
        this.handleNavLeave = this.handleNavLeave.bind(this);
        this.handleDesktopChange = this.handleDesktopChange.bind(this);

        this.menus.forEach((menu) => {
          menu.addEventListener('toggle', this.handleToggle);
        });

        this.nav.addEventListener('mouseleave', this.handleNavLeave);

        this.desktopQuery.addEventListener?.(
          'change',
          this.handleDesktopChange
        );

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            if (this.activeMenu?.open) {
              this.show(this.activeMenu);
            }
          });

          this.menus.forEach((menu) => {
            const panel = menu.querySelector(
              ':scope > .mega-menu__content'
            );

            if (panel) {
              this.resizeObserver.observe(panel);
            }
          });
        }

        const initiallyOpen = this.menus.find((menu) => menu.open);

        if (initiallyOpen && this.desktopQuery.matches) {
          this.show(initiallyOpen);
        }
      }

      handleToggle(event) {
        if (!this.desktopQuery.matches) {
          this.reset();
          return;
        }

        const menu = event.currentTarget;

        if (menu.open) {
          this.show(menu);
          return;
        }

        const replacement = this.menus.find(
          (candidate) => candidate.open
        );

        if (replacement) {
          this.show(replacement);
        } else {
          const anotherMegaMenuIsHovered = this.menus.some((candidate) => {
            if (candidate === menu) return false;

            const summary = candidate.querySelector(':scope > summary');
            return summary?.matches(':hover');
          });

          this.scheduleHide(anotherMegaMenuIsHovered);
        }
      }

      handleNavLeave() {
        if (!this.desktopQuery.matches) return;

        const openMenu = this.menus.find((menu) => menu.open);

        if (!openMenu) {
          this.scheduleHide(false);
        }
      }

      show(menu) {
        const panel = menu.querySelector(
          ':scope > .mega-menu__content'
        );

        if (!panel) return;

        window.clearTimeout(this.hideTimer);
        this.nav.classList.remove('ph-mega-stage-instant-close');
        this.activeMenu = menu;

        if (this.measureFrame) {
          cancelAnimationFrame(this.measureFrame);
        }

        this.measureFrame = requestAnimationFrame(() => {
          const rect = panel.getBoundingClientRect();
          const panelHeight = Math.ceil(rect.height);

          if (panelHeight > 0) {
            this.nav.style.setProperty(
              '--ph-mega-stage-height',
              `${panelHeight}px`
            );
          }

          this.nav.style.setProperty(
            '--ph-mega-overlay-top',
            `${Math.round(rect.top)}px`
          );

          this.nav.classList.add('ph-mega-stage-active');
          this.measureFrame = null;
        });
      }

      scheduleHide(keepHandoverDelay = false) {
        window.clearTimeout(this.hideTimer);

        const closeStage = (instant = false) => {
          const replacement = this.menus.find((menu) => menu.open);

          if (replacement) {
            this.show(replacement);
            return;
          }

          if (instant) {
            this.nav.classList.add('ph-mega-stage-instant-close');
          }

          this.nav.classList.remove('ph-mega-stage-active');
          this.activeMenu = null;

          if (instant) {
            requestAnimationFrame(() => {
              this.nav.classList.remove('ph-mega-stage-instant-close');
            });
          }
        };

        const delay =
          this.reducedMotionQuery.matches || !keepHandoverDelay
            ? 0
            : 280;

        if (delay === 0) {
          closeStage(true);
          return;
        }

        this.hideTimer = window.setTimeout(() => closeStage(false), delay);
      }

      handleDesktopChange(event) {
        if (!event.matches) {
          this.reset();
          return;
        }

        const openMenu = this.menus.find((menu) => menu.open);

        if (openMenu) {
          this.show(openMenu);
        }
      }

      reset() {
        window.clearTimeout(this.hideTimer);

        if (this.measureFrame) {
          cancelAnimationFrame(this.measureFrame);
          this.measureFrame = null;
        }

        this.nav.classList.remove('ph-mega-stage-active');
        this.nav.classList.remove('ph-mega-stage-instant-close');
        this.nav.style.removeProperty('--ph-mega-stage-height');
        this.nav.style.removeProperty('--ph-mega-overlay-top');
        this.activeMenu = null;
      }
    }

    const initialiseMegaMenuHandovers = (scope = document) => {
      scope.querySelectorAll('.header__inline-menu').forEach((nav) => {
        if (!nav.phMegaMenuHandover) {
          nav.phMegaMenuHandover = new MegaMenuHandover(nav);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initialiseMegaMenuHandovers(),
        { once: true }
      );
    } else {
      initialiseMegaMenuHandovers();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseMegaMenuHandovers(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headerbackupSept26"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
      this.onMobileMenuToggle = this.onMobileMenuToggle.bind(this);
      this.onMobileMenuMutation = this.onMobileMenuMutation.bind(this);
      this.onMobileMenuSummaryClick = this.onMobileMenuSummaryClick.bind(this);
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');

      if (!this.header) return;

      this.nav = this.querySelector('.header__inline-menu');
      this.mainHeader = this.querySelector('.header');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.desktopMedia = window.matchMedia('(min-width: 990px)');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.viewportWidth = this.getViewportWidth();
      this.desktopState = this.isDesktop();

      this.lastScrollTop = this.getScrollTop();
      this.scrollAnchor = this.lastScrollTop;

      /* Hysteresis thresholds prevent tiny trackpad movements from repeatedly
         reversing the header state. Desktop uses a deliberately larger travel
         distance because collapsing the navigation changes the header height. */
      this.desktopHideThreshold = 120;
      this.desktopRevealThreshold = 36;
      this.mobileHideThreshold = 22;
      this.mobileRevealThreshold = 14;

      /* When returning towards the top on desktop, restore the full navigation
         before the sticky header reaches the announcement-bar handover area.
         This is based only on page scroll position, so the two sections remain
         independent. */
      this.desktopTopRevealPoint = 520;

      this.hideStart = 40;
      this.transitionLockUntil = 0;
      this.transitionTimer = null;
      this.scrollTicking = false;
      this.resizeTimer = null;

      this.mobileAnimationTargetHidden = false;
      this.mobileTransitionFrame = null;
      this.pageScrollLocked = false;
      this.lockedScrollY = 0;
      this.scrollLockState = null;
      this.mobileMenuDetails = null;
      this.mobileMenuSummary = null;
      this.mobileMenuObserver = null;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'shopify-section-header-initialising'
      );

      this.measureHeader();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      window.addEventListener('pageshow', this.onPageShow);

      this.setupMobileMenuLock();

      if (!this.isDesktop()) {
        this.animateMobilePanel(false, true);
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.lastScrollTop = this.getScrollTop();
          this.header.classList.remove('shopify-section-header-initialising');
        });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('pageshow', this.onPageShow);
      window.clearTimeout(this.resizeTimer);
      window.clearTimeout(this.transitionTimer);
      document.documentElement.classList.remove('ph-header-transitioning');

      this.cancelMobileAnimation(true);

      this.mobileMenuDetails?.removeEventListener(
        'toggle',
        this.onMobileMenuToggle
      );

      this.mobileMenuSummary?.removeEventListener(
        'click',
        this.onMobileMenuSummaryClick,
        true
      );

      this.mobileMenuObserver?.disconnect();
      this.unlockPageScroll();

      this.header?.classList.remove(
        'ph-mobile-menu-preparing',
        'ph-mobile-menu-open'
      );

      this.header?.style.removeProperty('--ph-mobile-menu-top');
    }

    getScrollTop() {
      return Math.max(
        window.pageYOffset || document.documentElement.scrollTop || 0,
        0
      );
    }

    getViewportWidth() {
      return Math.round(
        document.documentElement.clientWidth || window.innerWidth || 0
      );
    }

    isDesktop() {
      return this.desktopMedia.matches;
    }

    isHeaderHidden() {
      return this.isDesktop()
        ? this.header.classList.contains('shopify-section-header-hidden')
        : this.header.classList.contains('ph-mobile-header-hidden');
    }

    measureHeader() {
      let navHeight = 0;

      if (this.nav) {
        /* Measure the visible navigation wrapper rather than scrollHeight.
           scrollHeight includes the invisible desktop mega-menu hover bridge. */
        const navContent = this.nav.firstElementChild;

        navHeight = Math.ceil(
          (navContent || this.nav).getBoundingClientRect().height
        );
      }

      if (navHeight) {
        this.header.style.setProperty('--ph-header-nav-height', `${navHeight}px`);
      }

      const fullHeaderHeight = Math.ceil(this.header.offsetHeight);

      document.documentElement.style.setProperty(
        '--header-height',
        `${fullHeaderHeight}px`
      );

      this.updateLiveHeaderHeight();
    }

      updateLiveHeaderHeight() {
        requestAnimationFrame(() => {
          const liveHeight = Math.ceil(
            this.header.offsetHeight
          );

          if (
            liveHeight ===
            this.lastLiveHeaderHeight
          ) {
            return;
          }

          this.lastLiveHeaderHeight =
            liveHeight;

          document.documentElement.style.setProperty(
            '--header-height-live',
            `${liveHeight}px`
          );
        });
      }

    cancelMobileAnimation(clearTransform = false) {
      if (this.mobileTransitionFrame) {
        cancelAnimationFrame(this.mobileTransitionFrame);
        this.mobileTransitionFrame = null;
      }

      this.style.removeProperty('transition');
      this.style.removeProperty('--ph-mobile-header-duration');

      if (clearTransform) {
        this.style.removeProperty('transform');
      }
    }

    animateMobilePanel(hidden, immediate = false) {
      if (this.isDesktop()) return;

      const targetTransform = hidden
        ? 'translate3d(0, -101%, 0)'
        : 'translate3d(0, 0, 0)';

      this.mobileAnimationTargetHidden = hidden;

      if (this.mobileTransitionFrame) {
        cancelAnimationFrame(this.mobileTransitionFrame);
        this.mobileTransitionFrame = null;
      }

      if (immediate) {
        /* Establish the requested position without animation, then restore the
           persistent CSS transition on the following frame. This is used only
           for initial load, page restoration and breakpoint changes. */
        this.style.setProperty('transition', 'none', 'important');
        this.style.setProperty('transform', targetTransform, 'important');

        /* Force the browser to commit the non-animated position before the
           transition is re-enabled. */
        void this.offsetHeight;

        this.mobileTransitionFrame = requestAnimationFrame(() => {
          this.style.removeProperty('transition');
          this.mobileTransitionFrame = null;
        });

        return;
      }

      /* Do not calculate, cancel or restart an animation. Changing only the
         transform destination lets the browser's native transition continue
         from the panel's exact current visual position. This also makes rapid
         direction changes reverse smoothly instead of snapping. */
      this.style.removeProperty('transition');
      this.style.setProperty('--ph-mobile-header-duration', '440ms');
      this.style.setProperty('transform', targetTransform, 'important');
    }

    setupMobileMenuLock() {
      this.mobileMenuDetails = this.querySelector(
        'header-drawer > details, header-drawer details.menu-drawer-container, details.menu-drawer-container'
      );

      if (!this.mobileMenuDetails) return;

      this.mobileMenuSummary = this.mobileMenuDetails.querySelector('summary');

      this.mobileMenuDetails.addEventListener(
        'toggle',
        this.onMobileMenuToggle
      );

      this.mobileMenuSummary?.addEventListener(
        'click',
        this.onMobileMenuSummaryClick,
        true
      );

      this.mobileMenuObserver = new MutationObserver(
        this.onMobileMenuMutation
      );

      this.mobileMenuObserver.observe(this.mobileMenuDetails, {
        attributes: true,
        attributeFilter: ['open', 'class']
      });

      this.onMobileMenuToggle();
    }

    onMobileMenuMutation() {
      this.onMobileMenuToggle();
    }

    onMobileMenuSummaryClick() {
      if (
        this.isDesktop() ||
        !this.mobileMenuDetails ||
        this.mobileMenuDetails.open
      ) {
        return;
      }

      /*
       * This runs before the native details toggle.
       * Removing the transform first allows the drawer to calculate its
       * position from the viewport.
       */
      this.prepareMobileMenuOpen();
    }

    prepareMobileMenuOpen() {
      if (this.isDesktop() || !this.header) return;

      const currentTop = Math.max(
        0,
        Math.round(this.header.getBoundingClientRect().top)
      );

      this.header.style.setProperty(
        '--ph-mobile-menu-top',
        `${currentTop}px`
      );

      this.header.classList.add(
        'shopify-section-header-sticky',
        'scrolling-up',
        'ph-mobile-menu-preparing'
      );

      this.header.classList.remove(
        'ph-mobile-header-hidden',
        'shopify-section-header-hidden',
        'scrolling-down',
        'animate'
      );

      this.cancelMobileAnimation(false);
      this.style.setProperty('transition', 'none', 'important');
      this.style.removeProperty('transform');

      /*
       * Force the browser to commit transform:none before the drawer
       * calculates its opening position.
       */
      void this.offsetHeight;
    }

    finishMobileMenuClose() {
      if (!this.header) return;

      this.unlockPageScroll();

      this.header.classList.remove(
        'ph-mobile-menu-preparing',
        'ph-mobile-menu-open'
      );

      this.header.style.removeProperty('--ph-mobile-menu-top');

      /*
       * Return the header to its standard visible mobile state without
       * animating from the temporary fixed position.
       */
      this.animateMobilePanel(false, true);

      this.header.classList.remove(
        'ph-mobile-header-hidden',
        'scrolling-down'
      );

      this.header.classList.add(
        'shopify-section-header-sticky',
        'scrolling-up'
      );

      this.lastScrollTop = this.getScrollTop();
      this.scrollAnchor = this.lastScrollTop;
    }

    onMobileMenuToggle() {
      const menuIsOpen = Boolean(
        this.mobileMenuDetails &&
        (
          this.mobileMenuDetails.open ||
          this.mobileMenuDetails.classList.contains('menu-opening')
        )
      );

      if (menuIsOpen && !this.isDesktop()) {
        this.prepareMobileMenuOpen();

        this.header.classList.add('ph-mobile-menu-open');
        this.header.classList.remove('ph-mobile-menu-preparing');

        this.lockPageScroll();
        return;
      }

      this.finishMobileMenuClose();
    }

    lockPageScroll() {
      if (this.pageScrollLocked || this.isDesktop()) return;

      const html = document.documentElement;
      const body = document.body;

      this.pageScrollLocked = true;
      this.lockedScrollY = this.getScrollTop();
      this.scrollLockState = {
        htmlOverflow: html.style.overflow,
        bodyOverflow: body.style.overflow,
        htmlOverscrollBehavior: html.style.overscrollBehavior,
        bodyOverscrollBehavior: body.style.overscrollBehavior
      };

      html.classList.add('ph-mobile-menu-locked');
      body.classList.add('ph-mobile-menu-locked');

      /* Keep the document at its real scroll position. Fixing the body and
         applying a negative top offset causes the visible page to jump when
         the drawer opens and closes, especially with mobile browser chrome. */
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
      html.style.overscrollBehavior = 'none';
      body.style.overscrollBehavior = 'none';
    }

    unlockPageScroll() {
      if (!this.pageScrollLocked) return;

      const html = document.documentElement;
      const body = document.body;
      const state = this.scrollLockState || {};

      const restore = (element, property, value) => {
        if (value) {
          element.style.setProperty(property, value);
        } else {
          element.style.removeProperty(property);
        }
      };

      restore(html, 'overflow', state.htmlOverflow);
      restore(body, 'overflow', state.bodyOverflow);
      restore(
        html,
        'overscroll-behavior',
        state.htmlOverscrollBehavior
      );
      restore(
        body,
        'overscroll-behavior',
        state.bodyOverscrollBehavior
      );

      html.classList.remove('ph-mobile-menu-locked');
      body.classList.remove('ph-mobile-menu-locked');

      this.pageScrollLocked = false;
      this.scrollLockState = null;
      this.lockedScrollY = 0;

      /* The page never left its original scroll position, so no restorative
         window.scrollTo call is required. Avoiding that call removes the
         closing jump as well. */
      const scrollTop = this.getScrollTop();
      this.lastScrollTop = scrollTop;
      this.scrollAnchor = scrollTop;
    }

    onResize() {
      const nextWidth = this.getViewportWidth();
      const nextDesktopState = this.isDesktop();
      const breakpointChanged = nextDesktopState !== this.desktopState;
      const widthChanged = Math.abs(nextWidth - this.viewportWidth) >= 8;

      /* Mobile browsers frequently emit resize events when the address bar
         expands or contracts during a normal scroll. Those events alter the
         viewport height, not the layout width, and must not reset the header.
         The previous handler called reveal(false), causing an occasional snap. */
      if (!breakpointChanged && !widthChanged) return;

      window.clearTimeout(this.resizeTimer);

      this.resizeTimer = window.setTimeout(() => {
        const liveWidth = this.getViewportWidth();
        const liveDesktopState = this.isDesktop();
        const liveBreakpointChanged = liveDesktopState !== this.desktopState;
        const liveWidthChanged = Math.abs(liveWidth - this.viewportWidth) >= 8;

        if (!liveBreakpointChanged && !liveWidthChanged) return;

        this.header.classList.add('shopify-section-header-initialising');

        /* Only reset visibility when crossing the desktop/mobile breakpoint.
           Ordinary width changes preserve the current hidden or visible state. */
        if (liveBreakpointChanged) {
          this.cancelMobileAnimation(liveDesktopState);

          if (liveDesktopState) {
            this.unlockPageScroll();
          }

          this.reveal(false);
        }

        requestAnimationFrame(() => {
          this.measureHeader();
          this.viewportWidth = liveWidth;
          this.desktopState = liveDesktopState;
          this.lastScrollTop = this.getScrollTop();
          this.scrollAnchor = this.lastScrollTop;
          this.transitionLockUntil = 0;
          this.header.classList.remove('shopify-section-header-initialising');
        });
      }, 120);
    }

    onPageShow() {
      this.lastScrollTop = this.getScrollTop();
      this.scrollAnchor = this.lastScrollTop;
      this.transitionLockUntil = 0;
      this.reveal(false);
      this.measureHeader();
    }

    interactionIsOpen() {
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return true;

      return Boolean(
        this.querySelector('details[open], .menu-opening, [aria-expanded="true"].header__icon--menu')
      );
    }

    onScroll() {
      if (this.scrollTicking) return;

      this.scrollTicking = true;

      requestAnimationFrame(() => {
        this.scrollTicking = false;

        const scrollTop = this.getScrollTop();
        const now = performance.now();
        const previousScrollTop = this.lastScrollTop;
        const scrollingUp = scrollTop < previousScrollTop;

        this.lastScrollTop = scrollTop;

        if (this.pageScrollLocked) {
          this.scrollAnchor = this.lockedScrollY;
          return;
        }

        /* Keep the complete desktop header and navigation row permanently
           visible. Mobile retains its independent hide and reveal behaviour. */
        if (this.isDesktop()) {
          this.scrollAnchor = scrollTop;

          if (this.header.classList.contains('shopify-section-header-hidden')) {
            this.reveal(false);
          }

          return;
        }

        if (this.headerIsAlwaysSticky) {
          this.scrollAnchor = scrollTop;
          this.reveal();
          return;
        }

        /* Desktop top-approach safety zone. If the user is moving upwards,
           reveal the full navigation while there is still ample page distance
           for its height transition to finish. The announcement bar is neither
           queried nor controlled here. */
        if (
          this.isDesktop() &&
          scrollingUp &&
          scrollTop <= this.desktopTopRevealPoint
        ) {
          this.header.classList.add('ph-desktop-pretop-reveal');
          this.scrollAnchor = scrollTop;
          this.reveal();
          return;
        }

        if (this.isDesktop() && scrollTop > this.desktopTopRevealPoint) {
          this.header.classList.remove('ph-desktop-pretop-reveal');
        }

        if (scrollTop <= this.hideStart) {
          if (this.isDesktop()) {
            this.header.classList.add('ph-desktop-pretop-reveal');
          }

          this.scrollAnchor = scrollTop;
          this.reveal();
          return;
        }

        if (this.interactionIsOpen()) {
          this.scrollAnchor = scrollTop;
          this.reveal();
          return;
        }

        /* Ignore scroll events produced while the header itself is changing
           height or position. Continue updating the anchor so no artificial
           distance is carried into the next genuine user scroll. */
        if (now < this.transitionLockUntil) {
          this.scrollAnchor = scrollTop;
          return;
        }

        const hidden = this.isHeaderHidden();
        const hideThreshold = this.isDesktop()
          ? this.desktopHideThreshold
          : this.mobileHideThreshold;
        const revealThreshold = this.isDesktop()
          ? this.desktopRevealThreshold
          : this.mobileRevealThreshold;

        if (!hidden) {
          /* While visible, an upward movement establishes a new low point.
             The header only hides after a deliberate downward journey from it. */
          if (scrollTop < this.scrollAnchor) {
            this.scrollAnchor = scrollTop;
            return;
          }

          if (scrollTop - this.scrollAnchor < hideThreshold) return;

          this.scrollAnchor = scrollTop;
          this.hide();
          return;
        }

        /* While hidden, a downward movement establishes a new high point.
           The header only reveals after a deliberate upward journey from it. */
        if (scrollTop > this.scrollAnchor) {
          this.scrollAnchor = scrollTop;
          return;
        }

        if (this.scrollAnchor - scrollTop < revealThreshold) return;

        this.scrollAnchor = scrollTop;
        this.reveal();
      });
    }

    lockScrollDuringTransition() {
      /* The lock is only required on desktop, where collapsing the navigation
         changes the header height and can create synthetic reverse-scroll
         events. Mobile uses transform only, so locking it prevents a fast
         upward gesture from smoothly reversing an in-progress hide animation. */
      if (!this.isDesktop()) {
        this.transitionLockUntil = 0;
        document.documentElement.classList.remove('ph-header-transitioning');
        window.clearTimeout(this.transitionTimer);
        return;
      }

      const duration = 430;

      this.transitionLockUntil = performance.now() + duration;
      document.documentElement.classList.add('ph-header-transitioning');
      window.clearTimeout(this.transitionTimer);

      this.transitionTimer = window.setTimeout(() => {
        document.documentElement.classList.remove('ph-header-transitioning');
        this.lastScrollTop = this.getScrollTop();
        this.scrollAnchor = this.lastScrollTop;
        this.transitionLockUntil = 0;
      }, duration + 40);
    }

    hide() {
      if (!this.isDesktop()) {
        if (
          this.header.classList.contains('ph-mobile-header-hidden') ||
          this.pageScrollLocked
        ) {
          return;
        }

        this.header.classList.add(
          'ph-mobile-header-hidden',
          'shopify-section-header-sticky',
          'scrolling-down'
        );

        this.header.classList.remove(
          'shopify-section-header-hidden',
          'ph-desktop-pretop-reveal',
          'animate',
          'scrolling-up'
        );

        this.animateMobilePanel(true);
        this.closeMenuDisclosure();
        this.closeSearchModal();
        this.updateLiveHeaderHeight();
        return;
      }

      if (this.header.classList.contains('shopify-section-header-hidden')) return;

      this.header.classList.remove('ph-mobile-header-hidden');
      this.lockScrollDuringTransition();

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'scrolling-down'
      );

      this.header.classList.remove('animate', 'scrolling-up');

      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.updateLiveHeaderHeight();
    }

    reveal(animate = true) {
      if (!this.isDesktop()) {
        this.header.classList.add(
          'shopify-section-header-sticky',
          'scrolling-up'
        );
        this.header.classList.toggle('animate', animate);

        this.header.classList.remove(
          'ph-mobile-header-hidden',
          'shopify-section-header-hidden',
          'scrolling-down'
        );

        this.animateMobilePanel(false, !animate);
        this.updateLiveHeaderHeight();
        return;
      }

      this.cancelMobileAnimation(true);
      this.header.classList.remove('ph-mobile-header-hidden');

      const wasHidden = this.header.classList.contains('shopify-section-header-hidden');

      if (wasHidden && animate) {
        this.lockScrollDuringTransition();
      }

      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.toggle('animate', animate);
      this.header.classList.add('scrolling-up');

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'scrolling-down'
      );

      this.updateLiveHeaderHeight();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        } else {
          disclosure.querySelector('details[open]')?.removeAttribute('open');
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  (() => {
    class MegaMenuHandover {
      constructor(nav) {
        this.nav = nav;
        this.stage = nav.querySelector(':scope > .ph-mega-stage');
        this.menus = Array.from(nav.querySelectorAll('details.mega-menu'));

        if (
          !this.stage ||
          !this.menus.length ||
          nav.dataset.phMegaHandover === 'true'
        ) {
          return;
        }

        nav.dataset.phMegaHandover = 'true';

        this.desktopQuery = window.matchMedia(
          '(min-width: 990px) and (hover: hover) and (pointer: fine)'
        );

        this.reducedMotionQuery = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        this.activeMenu = null;
        this.hideTimer = null;
        this.measureFrame = null;

        this.handleToggle = this.handleToggle.bind(this);
        this.handleSummaryEnter = this.handleSummaryEnter.bind(this);
        this.handleNavLeave = this.handleNavLeave.bind(this);
        this.handleDesktopChange = this.handleDesktopChange.bind(this);

        this.menus.forEach((menu) => {
          menu.addEventListener('toggle', this.handleToggle);

          const summary = menu.querySelector(':scope > summary');
          summary?.addEventListener('mouseenter', this.handleSummaryEnter);
        });

        this.nav.addEventListener('mouseleave', this.handleNavLeave);

        this.desktopQuery.addEventListener?.(
          'change',
          this.handleDesktopChange
        );

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            if (this.activeMenu?.open) {
              this.show(this.activeMenu);
            }
          });

          this.menus.forEach((menu) => {
            const panel = menu.querySelector(
              ':scope > .mega-menu__content'
            );

            if (panel) {
              this.resizeObserver.observe(panel);
            }
          });
        }

        const initiallyOpen = this.menus.find((menu) => menu.open);

        if (initiallyOpen && this.desktopQuery.matches) {
          initiallyOpen.dataset.phMegaHasOpened = 'true';
          this.show(initiallyOpen);
        }
      }

      handleToggle(event) {
        if (!this.desktopQuery.matches) {
          this.reset();
          return;
        }

        const menu = event.currentTarget;

        if (menu.open) {
          const hasOpenedBefore = menu.dataset.phMegaHasOpened === 'true';

          this.show(menu);

          if (hasOpenedBefore) {
            this.restartEntrance(menu);
          } else {
            menu.dataset.phMegaHasOpened = 'true';
          }

          return;
        }

        const replacement = this.menus.find(
          (candidate) => candidate.open
        );

        if (replacement) {
          this.show(replacement);
        } else {
          const anotherMegaMenuIsHovered = this.menus.some((candidate) => {
            if (candidate === menu) return false;

            const summary = candidate.querySelector(':scope > summary');
            return summary?.matches(':hover');
          });

          this.scheduleHide(anotherMegaMenuIsHovered);
        }
      }

      handleSummaryEnter(event) {
        if (
          !this.desktopQuery.matches ||
          this.reducedMotionQuery.matches
        ) {
          return;
        }

        const menu = event.currentTarget.closest('details.mega-menu');

        if (
          !menu ||
          !menu.open ||
          menu.dataset.phMegaHasOpened !== 'true'
        ) {
          return;
        }

        this.restartEntrance(menu);
      }

      restartEntrance(menu) {
        if (this.reducedMotionQuery.matches) return;

        const now = performance.now();
        const lastRestart = Number(menu.dataset.phMegaLastRestart || 0);

        if (now - lastRestart < 120) return;

        menu.dataset.phMegaLastRestart = String(now);

        const panel = menu.querySelector(
          ':scope > .mega-menu__content'
        );

        if (!panel) return;

        panel.classList.remove('ph-mega-reenter-start');
        void panel.offsetHeight;
        panel.classList.add('ph-mega-reenter-start');

        requestAnimationFrame(() => {
          panel.classList.remove('ph-mega-reenter-start');
        });
      }

      handleNavLeave() {
        if (!this.desktopQuery.matches) return;

        const openMenu = this.menus.find((menu) => menu.open);

        if (!openMenu) {
          this.scheduleHide(false);
        }
      }

      show(menu) {
        const panel = menu.querySelector(
          ':scope > .mega-menu__content'
        );

        if (!panel) return;

        window.clearTimeout(this.hideTimer);
        this.nav.classList.remove('ph-mega-stage-instant-close');
        this.activeMenu = menu;

        if (this.measureFrame) {
          cancelAnimationFrame(this.measureFrame);
        }

        this.measureFrame = requestAnimationFrame(() => {
          const rect = panel.getBoundingClientRect();
          const panelHeight = Math.ceil(rect.height);

          if (panelHeight > 0) {
            this.nav.style.setProperty(
              '--ph-mega-stage-height',
              `${panelHeight}px`
            );
          }

          this.nav.style.setProperty(
            '--ph-mega-overlay-top',
            `${Math.round(rect.top)}px`
          );

          this.nav.classList.add('ph-mega-stage-active');
          this.measureFrame = null;
        });
      }

      scheduleHide(keepHandoverDelay = false) {
        window.clearTimeout(this.hideTimer);

        const closeStage = (instant = false) => {
          const replacement = this.menus.find((menu) => menu.open);

          if (replacement) {
            this.show(replacement);
            return;
          }

          if (instant) {
            this.nav.classList.add('ph-mega-stage-instant-close');
          }

          this.nav.classList.remove('ph-mega-stage-active');
          this.activeMenu = null;

          if (instant) {
            requestAnimationFrame(() => {
              this.nav.classList.remove('ph-mega-stage-instant-close');
            });
          }
        };

        const delay =
          this.reducedMotionQuery.matches || !keepHandoverDelay
            ? 0
            : 280;

        if (delay === 0) {
          closeStage(true);
          return;
        }

        this.hideTimer = window.setTimeout(() => closeStage(false), delay);
      }

      handleDesktopChange(event) {
        if (!event.matches) {
          this.reset();
          return;
        }

        const openMenu = this.menus.find((menu) => menu.open);

        if (openMenu) {
          this.show(openMenu);
        }
      }

      reset() {
        window.clearTimeout(this.hideTimer);

        if (this.measureFrame) {
          cancelAnimationFrame(this.measureFrame);
          this.measureFrame = null;
        }

        this.nav.classList.remove('ph-mega-stage-active');
        this.nav.classList.remove('ph-mega-stage-instant-close');
        this.nav.style.removeProperty('--ph-mega-stage-height');
        this.nav.style.removeProperty('--ph-mega-overlay-top');
        this.activeMenu = null;
      }
    }

    const initialiseMegaMenuHandovers = (scope = document) => {
      scope.querySelectorAll('.header__inline-menu').forEach((nav) => {
        if (!nav.phMegaMenuHandover) {
          nav.phMegaMenuHandover = new MegaMenuHandover(nav);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initialiseMegaMenuHandovers(),
        { once: true }
      );
    } else {
      initialiseMegaMenuHandovers();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseMegaMenuHandovers(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
